import React, { useEffect, useState } from 'react'
import axios from 'axios';
import SideMain from './SideMain';
import Audio from  'react-loader-spinner'
import ForecastCard from './ForecastCard';
import HighlightBox from './HighlightBox';
import Loader from 'react-loader-spinner';
export default function Main(){
    
    let [dataArr,setDataArr]=useState([]);
    let [places,setPlaces]=useState(["London","Helsinki"]);
    const [CurrPlace, setCurrPlace] = useState("Helsinki")
   
    
    useEffect(()=>{
        getData();
    },[CurrPlace]);


    async function getData(){
        await axios.get(`https://weatherappserver.herokuapp.com/api/location?currPlace=${CurrPlace}`).then( async data=>{
            
            
             await axios.get(`https://weatherappserver.herokuapp.com/api/getWeatherByLocation?woeid=${data.data[0].woeid}`,
                
             ).then(async data=>{
                
                    data.headers={...data.headers,"Access-Control-Allow-Origin":"*"};
                    console.log(data.headers);
                    setDataArr(data.data.consolidated_weather);
                    
                    

                
            }).catch(err=>{
                console.log(err);
            });
        }).catch(err=>{
            console.log(err);
        });

        
        
}

function getByUserLocation(){
        
        navigator.geolocation.getCurrentPosition((position)=>{
           const {latitude,longitude}=position.coords;
           getWeatherByCoord(latitude,longitude);
        });

}
function getWeatherByCoord(lat,long){
    console.log(lat+" "+long);
    axios.get(`https://weatherappserver.herokuapp.com/api/locationByCoord?lat=${(lat)}&long=${(long)}`).then(data=>{
        const userCity=data.data[0].title;
        if(userCity!==CurrPlace){
            console.log(data);
            setDataArr([]);
            setCurrPlace(userCity);
        }
        

    }).catch(err=>{
        console.log(err);
    })
    
}
function getPlaces(keywords){
    axios.get(`https://weatherappserver.herokuapp.com/api/location?currPlace=${keywords}`).then(data=>{
        setPlaces(data.data.map(place=>{
            return place.title
        }));
    });

}

function selectPlace(event){
    const selectedCity=event.target.getAttribute("value").toLowerCase()
    if(selectedCity!==CurrPlace){
        setDataArr([]);
        setCurrPlace(selectedCity);
    }
    
}

function searchPlace(event){
    getPlaces(event.target.value.toLowerCase());
}


if(dataArr.length!==0)
    var {air_pressure,humidity,wind_speed,visibility}=dataArr[0];
    return(
        <>
        {dataArr.length===0?<Loader
        className="loader"
    heigth="100"
    width="100"
    color='grey'
    
    ariaLabel='loading'
  />
            :
            <div className="flex mainDiv">
            
            <SideMain weatherArr={dataArr[0]} places={places} selectPlace={selectPlace} searchPlace={searchPlace} currPlace={CurrPlace} getByUserLocation={getByUserLocation}/>
            
            <div className="forecastSide flex">
                <div className="dayForecasts">
                    {dataArr.map((data,index)=>{
                        if(index!==0)
                            return <ForecastCard weatherArr={data} nextDate={index} key={index}/>
                        else return null;
                    })}
                </div>

                <p className="smallHeading text" style={{alignSelf:"center" ,marginTop:"2.5rem"}}>Today's Highlights</p>
                <div className="highlights text">
                    <HighlightBox title={"Wind Status"} value={wind_speed} unit={"mph"}/>
                    <HighlightBox title={"Humidity"} value={humidity} unit={"%"}/>

                    <HighlightBox title={"Visibility"} value={visibility} unit={" miles"}/>
                    <HighlightBox title={"Air Pressure"} value={air_pressure} unit={" mb"}/>


                </div>
                
            </div>

           
            
        </div>
            }
        
        </>
    )
   
    }

    

    
    

    

